module.exports = __webpack_public_path__ + "static/media/Elephant.58fa95bd.mp3";